export const getEquipData = (equipment) => {
  var Onsite = 0;
  var Pending = 0;
  var Operational = 0;
  var NeedsRepair = 0;

  equipment.forEach((equip) => {
    if (equip.hasOwnProperty("Status")) {
      if (equip["Status"] === "On site") {
        Onsite += 1;
      } else if (equip["Status"] === "Pending Install") {
        Pending += 1;
      } else if (equip["Status"] === "Operational") {
        Operational += 1;
      } else if (equip["Status"] === "Needs Repair") {
        NeedsRepair += 1;
      }
    }
  });

  return [
    { order: 1, name: `On site (${Onsite})`, value: Onsite, color: "#349fda" },
    {
      order: 2,
      name: `Pending Install (${Pending})`,
      value: Pending,
      color: "#fdd835",
    },
    {
      order: 3,
      name: `Operational (${Operational})`,
      value: Operational,
      color: "#50C878",
    },
    {
      order: 4,
      name: `Needs Repair (${NeedsRepair})`,
      value: NeedsRepair,
      color: "#f44336",
    },
  ];
};
